const DEBUG_KEY = 'sena_debug_medical_history';
const ENABLED_VALUES = new Set(['true', '1', 'yes', 'on']);

export function isMedicalHistoryDebugEnabled() {
  if (process.env.NODE_ENV === 'production') return false;

  try {
    const localValue = localStorage.getItem(DEBUG_KEY);
    const sessionValue = sessionStorage.getItem(DEBUG_KEY);
    const searchValue = new URLSearchParams(window.location.search).get('debugMedicalHistory');
    const windowValue = window.__SENA_MEDICAL_HISTORY_DEBUG__;

    return windowValue === true
      || ENABLED_VALUES.has(String(localValue || '').toLowerCase())
      || ENABLED_VALUES.has(String(sessionValue || '').toLowerCase())
      || ENABLED_VALUES.has(String(searchValue || '').toLowerCase());
  } catch {
    return false;
  }
}

export function logMedicalHistoryDebug(label, payload) {
  if (!isMedicalHistoryDebugEnabled()) return;

  console.group(`[medical-history] ${label}`);
  console.log(payload);
  console.groupEnd();
}

export { DEBUG_KEY as MEDICAL_HISTORY_DEBUG_KEY };
